import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-batch-dialog',
  templateUrl: './batch-dialog.component.html',
  styleUrls: ['./batch-dialog.component.css']
})
export class BatchDialogComponent implements OnInit {
  productId: string;
  gcp: string;
  batchNum: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
    this.batchNum = this.data.batchNum;
  }
}